import { Component } from '@angular/core';

@Component({
  selector: 'app-navbar',
  imports: [],
  templateUrl: './navbar.html',
  styleUrl: './navbar.scss'
})
export class Navbar {
  title = 'Flash Disk Prices - The easy to find the\n' +
    '      perfect drive for your needs and budget.';
}
